"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityCell = exports.EntityCellDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var cell_1 = require("../elements/cell");
var entity_image_link_1 = require("./entity-image-link");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
exports.EntityCellDefaultProps = {
  imageHeight: 90
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 272px;\n    font-size: ", ";\n  "], ["\n    max-width: 272px;\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(13))
});
var ImageLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n\n    ", "\n  "], ["\n    width: 100%;\n\n    ", "\n  "])), function (_a) {
    var imageHeight = _a.imageHeight;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), imageHeight);
  })
});
var NameStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1em;\n    display: inline-block;\n    line-height: 1.35em;\n    margin-top: ", ";\n    font-weight: 500;\n  "], ["\n    font-size: 1em;\n    display: inline-block;\n    line-height: 1.35em;\n    margin-top: ", ";\n    font-weight: 500;\n  "])), theme_1.theme.UNIT(1))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(cell_1.Cell)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Image: (0, styled_components_1.default)(entity_image_link_1.EntityImageLink)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ImageLinkStyles),
  Name: styled_components_1.default.span(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), NameStyles)
};
var EntityCell = function (props) {
  var className = props.className,
    entity = props.entity,
    children = props.children,
    imageHeight = props.imageHeight,
    rest = __rest(props, ["className", "entity", "children", "imageHeight"]);
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var label = props.label || (definition === null || definition === void 0 ? void 0 : definition.label);
  var components = definition === null || definition === void 0 ? void 0 : definition.components;
  var name = entity.name || entity.openGraph && entity.openGraph.title;
  var to = props.to || definition.to(entity.slug);
  return react_1.default.createElement(My.Container, __assign({}, rest, {
    to: to,
    className: className,
    label: label
  }), components.image ? react_1.default.createElement(components.image, {
    isCell: true,
    size: "medium",
    entity: entity
  }) : react_1.default.createElement(My.Image, {
    useIconFallback: true,
    imageHeight: imageHeight,
    entity: entity
  }), react_1.default.createElement(My.Name, null, children || name));
};
exports.EntityCell = EntityCell;
exports.EntityCell.defaultProps = exports.EntityCellDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;